import { useSeoMeta, useHead } from '@unhead/react';
import { ReviewCard } from '@/components/ReviewCard';
import { SiteShell } from '@/components/SiteShell';
import { PageHero } from '@/components/PageHero';
import { normalizeCanonicalUrl } from '@/lib/seo';
import reviewsBg from '../../images/VIP House Movers Team with happy customer.jpg';
import reviewsBanner from '../../images/VIP House Movers Team Carrying Items.jpg';
import reviewsImg1 from '../../images/VIP House Movers Removal Boxes.jpg';
import reviewsImg2 from '../../images/VIP House Movers Wrapping Sofas.jpg';
import reviewsImg3 from '../../images/VIP House Movers Home Removal Van.jpg';
import reviewsImg4 from '../../images/VIP House Movers Team with happy customer.jpg';

export default function Reviews() {
  // Enhanced reviews data with structured fields for schema
  const reviewsData = [
    { name: "Hannah Schuster", text: "My move all went smoothly thanks to the team; they worked hard all day. Competitive price and a really helpful company.", rating: 5, date: "2024-03-15" },
    { name: "Diane Wood", text: "Amazing service from start to finish , great price and lovely guys on the day , definitely recommend", rating: 5, date: "2024-03-10" },
    { name: "Andrew Beckett", text: "It's was the first time we ever moved, I read all about vip house movers, the reviews were very good, so we gave them a call. Best decision i ever did. Very professional, stress free, friendly, and easy to talk to. Can't thank them enough 👌", rating: 5, date: "2024-03-05" },
    { name: "Angela Beckett", text: "Absolutely brilliant so caring and professional would recommend 💯\nBest guy's out, could have a laugh while they carefully emptied the house and moved us to our new home .\nCan't thank them enough. Brilliant 👏", rating: 5, date: "2024-02-28" },
    { name: "Clare Harris", text: "They moved a 3 piece suite I'd found on Marketplace for me. Really nice polite and professional guys. Really happy with them", rating: 5, date: "2024-02-20" },
    { name: "Grace Phillips", text: "Staff was really friendly, very polite, extremely helpful too highly recommend, VIP House Movers helped me pick up some sofas and Val was great. He went to collect them and dropped them straight off for me. I'm a mom of 2 so it really helped a lot. Him and another lad sorry I forgot his name did great and made it all easy for me. Really appreciate the help.", rating: 5, date: "2024-02-15" },
    { name: "Melanie Guest", text: "VIP House Movers was brilliant! Elvis made my move simple and completely stress-free. We were a little worried because we have a lot of artwork and a piano, but he took charge and everything went perfectly. Thanks again to VIP House Movers for such an amazing experience!", rating: 5, date: "2024-02-10" },
    { name: "Rebecca Turner", text: "What a stress free experience I received!\nDue to being let down 24hours before complishion day! VIP house mover stepped and saves the day at such sort notice. They were truly amazing.", rating: 5, date: "2024-02-05" }
  ];

  useSeoMeta({
    title: 'Customer Reviews | Trusted Moving Company Wolverhampton | VIP House Movers',
    description: 'Read genuine 5-star reviews for VIP House Movers. Trusted by hundreds in Wolverhampton, Birmingham & West Midlands for house removals, man and van and packing services.',
    ogTitle: 'Customer Reviews | VIP House Movers Wolverhampton',
    ogDescription: 'Hundreds of genuine 5-star reviews for VIP House Movers. Trusted across Wolverhampton, Birmingham & the West Midlands.',
    ogImage: 'https://www.viphousemovers.com/og-home.jpg',
    ogUrl: 'https://www.viphousemovers.com/reviews',
    ogType: 'website',
    twitterCard: 'summary_large_image',
    twitterTitle: '5-Star Reviews | VIP House Movers Wolverhampton',
    twitterDescription: 'Genuine 5-star customer reviews for VIP House Movers across the West Midlands.',
    twitterImage: 'https://www.viphousemovers.com/og-home.jpg',
  });
  const canonicalHref = normalizeCanonicalUrl('https://www.viphousemovers.com/reviews');

  useHead({
    link: [{ rel: 'canonical', href: canonicalHref }],
    meta: [
      {
        name: 'keywords',
        content: 'VIP House Movers reviews, moving company testimonials, 5-star removal reviews, Wolverhampton removals reviews, customer reviews removals company, trusted movers feedback',
      },
    ],
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'VIP House Movers',
          url: 'https://www.viphousemovers.com',
          telephone: '+44-121-752-7107',
          email: 'info@viphousemovers.com',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Wolverhampton',
            addressRegion: 'West Midlands',
            addressCountry: 'GB',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '150',
            bestRating: '5',
            worstRating: '1',
          },
          review: reviewsData.map(r => ({
            '@type': 'Review',
            author: { '@type': 'Person', name: r.name },
            datePublished: r.date,
            reviewRating: {
              '@type': 'Rating',
              ratingValue: r.rating,
              bestRating: 5,
              worstRating: 1,
            },
            reviewBody: r.text,
          })),
        }),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'Home',
              item: 'https://www.viphousemovers.com',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Reviews',
              item: 'https://www.viphousemovers.com/reviews',
            },
          ],
        }),
      },
    ],
  });
  return (
    <SiteShell activePath="/reviews" fixedNav>
      <PageHero
        eyebrow="VIP House Movers Reviews"
        title="Customer reviews that speak for themselves"
        description="See why our customers rate VIP House Movers 5 stars for care, professionalism, and stress-free moves across Wolverhampton and beyond."
        align="center"
        backgroundImage={reviewsBg}
      />

      <div className="max-w-7xl mx-auto px-4 py-20">
        {/* Trust banner with image */}
        <div className="relative rounded-3xl overflow-hidden mb-16 bg-gray-900">
          <img
            src={reviewsBanner}
            alt="Happy VIP House Movers customer shaking hands with a professional removals team leader after a successful Wolverhampton house move"
            width={1600}
            height={600}
            loading="lazy"
            decoding="async"
            className="w-full h-64 md:h-80 object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/60 to-transparent flex items-center">
            <div className="px-8 md:px-16 max-w-2xl text-white">
              <p className="text-[#D4AF37] font-semibold uppercase tracking-wider text-sm mb-2">Trusted Across the Midlands</p>
              <h2 className="text-3xl md:text-4xl font-bold leading-tight">
                Rated 5 stars for care, professionalism & stress-free moves
              </h2>
              <p className="mt-4 text-gray-300 font-light">
                Over 100 successful moves a month across Wolverhampton, Birmingham, Staffordshire and nationwide UK.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviewsData.map((r, i) => (
            <ReviewCard key={i} name={r.name} text={r.text} />
          ))}
        </div>

        {/* Real-move gallery */}
        <section className="mt-20">
          <div className="text-center max-w-2xl mx-auto mb-10">
            <p className="text-[#D4AF37] font-semibold uppercase tracking-wider text-sm mb-2">Moves in progress</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Behind the scenes of a VIP move</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { src: reviewsImg1, alt: 'Packed moving boxes stacked and labelled by VIP House Movers ready for transport' },
              { src: reviewsImg2, alt: 'VIP House Movers carefully wrapping a sofa with protective blankets before loading' },
              { src: reviewsImg3, alt: 'Interior of a VIP House Movers removal lorry neatly loaded with household furniture' },
              { src: reviewsImg4, alt: 'Family unpacking boxes in their new home after a successful VIP House Movers relocation' },
            ].map((img) => (
              <div key={img.src} className="aspect-square overflow-hidden rounded-2xl shadow group">
                <img
                  src={img.src}
                  alt={img.alt}
                  width={600}
                  height={600}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            ))}
          </div>
        </section>
      </div>
    </SiteShell>
  );
}

